module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "disabled",
    on: {
      "click": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "menu-item-name"
  }, [_vm._v(_vm._s(_vm.$t("ui.menu." + _vm.item.name)))]), _vm._v(" "), _c('i', {
    staticClass: "icon yule-icon-lock"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d9b5874","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/partials/NavigationLockedItem.vue
// module id = 1876
// module chunks = 0